import information from './information'

export default information
